import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import { useAuthClient } from '@/lib/authClient';
import { User } from '@/types/user';

type ConsumeInvitationRequest = {
  signupToken: string;
  email: string;
};

type ConsumeInvitationResponse = User;

const consumeFetcher = async (
  url: string,
  { arg }: { arg: ConsumeInvitationRequest }
): Promise<ConsumeInvitationResponse> =>
  await denApi.post<ConsumeInvitationResponse, ConsumeInvitationRequest>(
    url,
    arg
  );

export function useConsumeInvitation(
  swrOptions?: SWRMutationConfiguration<
    ConsumeInvitationResponse,
    Error,
    string,
    ConsumeInvitationRequest
  >
) {
  const { user } = useAuthClient();
  const { trigger, isMutating, error } = useSWRMutation<
    ConsumeInvitationResponse,
    Error,
    string,
    ConsumeInvitationRequest
  >('organization/invitations/consume', consumeFetcher, swrOptions);

  const consume = async (signupToken: string) => {
    if (!user?.email) throw new Error('User email not available');
    return await trigger({ signupToken, email: user.email });
  };

  return { consume, isLoading: isMutating, error };
}
